import WPBaseDAO from "./WPBaseDao";
import ConteudoModel from "../../model/ConteudoModel";

class WPBuscaDAO extends WPBaseDAO {
  private static instance: WPBuscaDAO;
  private endpoint = `${super.getBasePath()}`;
  private endpointCache = `${super.getAPIPath()}/api`;
  
  private constructor() {
    super();
  }

  public static getInstance(): WPBuscaDAO {
    if (!WPBuscaDAO.instance) {
      WPBuscaDAO.instance = new WPBuscaDAO();
    }
    return WPBuscaDAO.instance;
  }

  public async getBusca(
    q: string,
    obterImagens: boolean
  ): Promise<ConteudoModel[]> {
    return this.get(
      `REQ_WP_LISTAS:${q}`,
      `${this.endpoint}/busca-total.php?textoItem=${q}`
    ).then((r: any) => {
      return Promise.all(
        r.data.map((i: any) =>
          ConteudoModel.toModel(i, "", obterImagens).then((c) => c)
        )
      );
    });
  }

  public async getProdutoBusca(
    q: string,
    obterImagens: boolean
  ): Promise<ConteudoModel[]> {
    return this.get(
      `REQ_WP_LISTAS_PRODUTO:${q}`,
      `${this.endpoint}/loop-produto.php?tipoConsulta=porSKU&idSKU=${q}`
    ).then((r: any) =>
      r.data.map((i: any) => ConteudoModel.toModel(i, "", obterImagens))
    );
  }

  public async getById(
    id: string,
    obterImagens: boolean
  ): Promise<ConteudoModel[]> {
    return this.get(
      `REQ_WP_LISTAS_PRODUTO_ID:${id}`,
      `${this.endpointCache}/Content/byID?contentId=${id}`
    ).then((r: any) =>
      Promise.all(
        r.data.data.map((i: any) =>
          ConteudoModel.toModel(i, "", obterImagens).then((c) => c)
        )
      )
    );
  }

  public async getBySKU(
    sku: string,
    obterImagens: boolean
  ): Promise<ConteudoModel[]> {
    return this.get(
      `REQ_WP_LISTAS_PRODUTO_SKU:${sku}`,
      `${this.endpoint}/loop-produto.php?tipoConsulta=porSKU&idSKU=${sku}`
    ).then(async (r: any) => {
      const conteudos: any = await Promise.all(
        r.data.map((i: any) => ConteudoModel.toModelProduto(i).then((c) => c))
      );
      const items: ConteudoModel[] = [];
      for (let conteudo of conteudos) {
        for (let item of conteudo) {
          items.push(item);
        }
      }

      return items;
    });
  }
}

export default WPBuscaDAO;
